import { Suspense, useContext, useRef } from 'react'
import { Canvas } from '@react-three/fiber'
import { PerspectiveCamera, OrbitControls, Html } from '@react-three/drei'
import Main from './components/Main'
import { StateContext } from './utils/State'
import Loader from './components/Loader/Loader'
import Controller from './components/Controller/Controller'
import { useLoader } from '@react-three/fiber'
import { OBJExporter } from "three/examples/jsm/exporters/OBJExporter"

const App = () => {
  const state = useContext(StateContext)

  // LISTENER
  const changeModelState = (type, payload) => state.dispatch({ type, payload })

  if (typeof window !== 'undefined') {
    window.changeModelState = changeModelState
  }

  return (
    <>
      {/* <Controller/> */}
      <Canvas gl={{ preserveDrawingBuffer: true }} >
        <OrbitControls 
          maxPolarAngle={Math.PI/2.5} 
          // enablePan={false}
          rotateSpeed={0.7}
          enableDamping={true}
          dampingFactor={0.1}
          maxDistance={50}
          // target={[3.25 - ((state.measures.width / 1000) + 4) / 2, 0, ((state.measures.length / 1000) / 2) - 2]}
          target={[3.25 - ((state.measures.width / 1000) + 4) / 2, 0, 0]}
        />
        {/* <axesHelper args={[2]} position={[0, 0, 0]}/> */}
        <Suspense fallback={<Html><Loader/></Html>}>
          <ambientLight args={[0xffffff, 0.5]}/>
          <directionalLight castShadow args={[0xffffff, 0.5]}/>
          <PerspectiveCamera
            makeDefault
            fov={60}
            position={[-2.143, 0, -6]}
          />
            <Main state={state}/>
        </Suspense>
      </Canvas>    
    </>
  )
}

export default App